import styled from "styled-components";
import { signOut } from "firebase/auth";
import { fireAuth } from "../../../Firebase/firebase";
import { desktopMarginsCutoff } from "../../../styleConstants";

const Button = styled.div`
  border-radius: 6px;
  border: 1px solid black;
  text-align: center;
  color: black;
  background: white;
  font-size: 14px;
  letter-spacing: 0.05em;
  font-weight: 500;
  height: 32px;
  line-height: 32px;
  width: calc(100% - 2px);
  // omitting max-width for mobiles and narrow tablets. let it fill the whole bottom. desktop below will impose a width.
  // max-width: 480px;
  transition-duration: 0.25s;
  transition-timing-function: ease-in;
  cursor: pointer;

  &:hover {
    background: black;
    color: white;
    border: 1px solid black;
  }

  @media screen and (min-width: ${desktopMarginsCutoff}px) {
    width: 360px;
  }
`;

const SignOutButton = () => (
  <Button onClick={() => signOut(fireAuth)}>SIGN OUT</Button>
);

export default SignOutButton;
